/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=442d3178&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=442d3178&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=442d3178&lang=scss"

import exportComponent from "/home/runner/work/Amiya-Bot-console2/Amiya-Bot-console2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442d3178"]])

export default __exports__